// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_1RkxeW","container":"ONWybE","content":"_3q9K7O","image":"_3z1n3_"};